export { AuthService } from './auth.service';
export { PublicGuard } from './public.guard';
export { ProtectedGuard } from './protected.guard';
export { AUTH_SERVICE,
  PUBLIC_FALLBACK_PAGE_URI,
  PROTECTED_FALLBACK_PAGE_URI
} from './tokens';
export { AuthModule } from './auth.module';



// WEBPACK FOOTER //
// ./~/ngx-auth/src/index.ts